const salesIconInit = () => {
  const productTag = document.querySelectorAll('.product-card-tags') as any;

  // eslint-disable-next-line prefer-destructuring, no-restricted-globals
  const width = screen.width;

  // eslint-disable-next-line arrow-parens
  productTag.forEach((element: any) => {
    if (element.classList.contains('sale_icon')) {
      // eslint-disable-next-line no-param-reassign
      element.style.marginBottom = '60px';
    } else {
      // eslint-disable-next-line no-param-reassign
      element.style.marginBottom = '0px';
      // eslint-disable-next-line no-param-reassign
      element.style.marginTop = '20px';
    }

    if (element.classList.contains('sale_icon') && width <= 600) {
      // eslint-disable-next-line no-param-reassign
      element.style.marginBottom = '40px';
      // eslint-disable-next-line no-param-reassign
      element.style.marginTop = '10px';
    }
  });
};

export default salesIconInit;
